<template>
	<div class="cleanserguide">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.routerGo('/skincarekeypoints')"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="inner_up">
                    <h1 class="guide_title">选择适合自己的洗面奶<span @click="$parent.routerGo('/cleansersurvey',(actParams = { query: $route.query, pageid: 577 }),{is_access:true,reportEvent_page_id:'577',reportEvent_page_name:'洁面-重填问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'洁面'})" v-show="redo_survey">重填问卷</span></h1>
                    <ul class="detail_menu">
                        <li class="menu_item" :class="focused_idx == 0 ? 'now' : ''" @click="changeFocusedTab(0);" ref="focused_item_0">特征分析</li>
                        <li class="menu_item" :class="focused_idx == 1 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:574 }),{is_access:true,reportEvent_page_id:574,reportEvent_page_name:'洁面-产品推荐',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'洁面'}));changeFocusedTab(1);" ref="focused_item_1">产品推荐</li>
                        <li class="menu_item" :class="focused_idx == 2 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:575 }),{is_access:true,reportEvent_page_id:575,reportEvent_page_name:'洁面-使用建议',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'洁面'}));changeFocusedTab(2);" ref="focused_item_2">使用建议</li>
                        <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
                    </ul>
                </div>
                <!-- 特征分析 -->
                <div class="inner_down inner_down_first" v-if="focused_idx == 0">
                    <div class="down_title">我的特征分析</div>
                    <div class="down_item down_item_mine">
                        <ul>
                            <li class="down_item_mine_result">{{(guidedata.dqmtype.length>0 ? '现状结果:' : '问卷信息:')+guidedata.ph_type}}肤质</li>
                            <li class="down_item_mine_result" v-if="guidedata.dqmtype.length>0">现状结果:屏障{{guidedata.dqmtype}}</li>
                            <li class="down_item_mine_result">问卷信息:自述{{guidedata.survey_3qs_desc}}</li>
                        </ul>
                        <p class="down_item_mine_summary">小结:{{guidedata.desc.feature_summary}}</p>

                    </div>
                    <template v-if="guidedata.desc.suitable_goods_type.length > 0">
                    <div class="down_title">适合的产品类型</div>
                    <ul class="down_item down_item_suitfor">
                        <template v-if="guidedata.desc.suitable_goods_type.includes('，')">
                        <li class="down_item_suitfor_name split" v-for="(suit_item,suit_idx) in guidedata.desc.suitable_goods_type.split('，')" :key="suit_idx">{{suit_item}}</li>
                        </template>
                        <template v-else>
                        <li class="down_item_suitfor_name nosplit">{{guidedata.desc.suitable_goods_type}}</li>
                        </template>
                        
                    </ul>
                    </template>
                    <template v-if="guidedata.desc.avoid_goods_type.length>0">
                    <div class="down_title">需要规避的产品类型</div>
                    <ul class="down_item down_item_avoid">
                      <template v-if="guidedata.desc.avoid_goods_type.includes('，')">
                        <li class="down_item_avoid_name" v-for="(avoid_item,avoid_idx) in guidedata.desc.avoid_goods_type.split('，')" :key="avoid_idx">{{avoid_item}}</li>
                      </template>
                      <template v-else>
                        <li class="down_item_avoid_name">{{guidedata.desc.avoid_goods_type}}</li>
                      </template>
                    </ul>
                    </template>

                    <div class="down_title">小科普</div>
                    <div class="down_item down_item_science">
                        <img src="../assets/images/cleanser_pop_science.png" alt="">
                        <div class="down_item_science_title">配方师科普:<br>如何挑选一款合适洁面产品</div>
                        <p class="down_item_science_desc">好的洁面要满足2个标准，一是洗得干净，二是不破坏皮肤屏障。我们将洁面产品的各项指标分解，按照清洁力（脱脂力）、是否含香精、是否存在风险性防腐剂、是否含有皂基成分、是否属于乳化型等五大维度评估，给不同肤质的你推荐最合适的洁面产品。比如油性还是干性需要选择相对应的清洁力，保证洗得干净但是不过度脱脂破坏屏障。非常敏感的人需要注意避免可能会带来刺激的成分，比如香精、风险性防腐剂、皂基。</p>
                    </div>



                </div>

                <!-- 产品推荐 -->
                <div class="inner_down inner_down_second" v-if="focused_idx ==1">
                  <div class="cleanser_sub_result_part">
                    <span class="cleanser_sub_result_show_text" @click="show_cleanser_toaster=true">推荐说明</span>
                    <div class="cleanser_sub_result_title">根据你的皮肤特征,为你推荐</div>
                    <div class="cleanser_sub_result_text">
                      <strong>{{cleanser_toaster_text[0]}}</strong>
                    </div>
                    <div class="cleanser_sub_result_text" v-if="cleanser_toaster_text.length == 2"><strong>{{cleanser_toaster_text[1]}}</strong></div>
                    
                  </div>
                <transition name="fade">
                  <div class="cleanser_toaster" v-show="show_cleanser_toaster">
                    <div class="cleanser_toaster_inner">
                      <img src="../assets/images/close_btn.svg" class="cleanser_inner_close_btn" @click="show_cleanser_toaster=false" alt="">
                      <div class="cleanser_toaster_inner_title"><strong>推荐说明</strong></div>
                      <div class="cleanser_toaster_inner_2nd_title">标有“推荐”字样的洁面产品：</div>
                      <p class="cleanser_toaster_inner_text">与你的匹配度较高，建议优先在这部分产品中选择你的洁面。匹配依据是你的肤质、敏感程度</p>
                      <div class="cleanser_toaster_inner_2nd_title">无“推荐”字样的洁面产品：</div>
                      <p class="cleanser_toaster_inner_text">与你的匹配度较低，不建议优先选择。但是你可以根据自己的洁面需求和使用历史，自主选择合适的产品</p>
                    </div>
                  </div>
                </transition>
                  <div class="down_title">洁面产品推荐</div>
                  <div class="filter_menu_outer">
                    <ul class="filter_menu" @click="($parent.trackLog((actParams = { query: $route.query, pageid:576 }),{is_access:true,reportEvent_page_id:576,reportEvent_page_name:'洁面-产品推荐-筛选',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'皮肤问题',reportEvent_third_module:'洁面'}))">
                      <li class="menu_item" :class="recommend == 1 ? 'now' : ''" @click="(recommend == 0 ? recommend = 1 : recommend =0),initProList()">只看推荐</li>
                      <li class="menu_item" :class="essence == 2 ? 'now' : ''" @click="(essence == 0 ? essence = 2 : essence =0),initProList()">无香精</li>
                      <li class="menu_item" :class="risk == 2 ? 'now' : ''" @click="(risk == 0 ? risk = 2 : risk =0),initProList()">防腐剂安全</li>
                      <li class="menu_item" :class="cleanser == 1 ? 'now' : ''" @click="(cleanser == 0 ? cleanser = 1 : cleanser =0),initProList()">清洁力强</li>
                      <li class="menu_item" :class="soap_base == 2 ? 'now' : ''" @click="(soap_base == 0 ? soap_base = 2 : soap_base =0),initProList()">非皂基</li>
                    </ul>
                  </div>
                  <ul class="filter_pro_list">
                    <template v-for="(pro_item,pro_idx) in rec_pro_list">
                    <li class="filter_pro" :key="'pro_idx'+pro_idx" :class="pro_item.recommend == 1 ? 'now' : pro_item.avoid == 1 ? 'avoid' : ''" v-if="rec_pro_list.length>0">
                      <img :src="pro_item.img" :key="pro_item.img" class="filter_pro_pic" alt="">
                      <div class="filter_pro_info">
                        <div class="pro_name">{{pro_item.name}}</div>
                        <div class="pro_price">参考价格:&yen;{{pro_item.price}}</div>
                       <div class="pro_buy" v-show="pro_item.name.includes('UNISKIN')" @click="$parent.goMallDetail(16);"><span>去购买</span><img src="../assets/images/arrow_right_d.svg" alt=""></div>
                      </div>
                    </li>
                    </template>
         

                    <!-- 规避产品 -->
                    <!-- <template  v-for="(avoid_item,avoid_idx) in avoid_pro_list">
                    <li class="filter_pro avoid" :key="'avoid_idx'+avoid_idx" v-if="(avoid_pro_list.length>0)">
                      <img :src="avoid_item.img" :key="avoid_item.img" class="filter_pro_pic" alt="">
                      <div class="filter_pro_info">
                        <div class="pro_name">{{avoid_item.name}}</div>
                        <div class="pro_price">参考价格:&yen;{{avoid_item.price}}</div>
                        <div class="pro_buy" v-show="avoid_item.name.includes('UNISKIN')" @click="$parent.goMallDetail(16);"><span>去购买</span><img src="../assets/images/arrow_right_d.svg" alt=""></div>
                      </div>
                    </li>
                    </template> -->
                  </ul>

                </div>

                <!-- 使用建议 -->
                <div class="inner_down inner_down_third" v-if="focused_idx == 2">
                    <div class="down_title">使用建议</div>
                    <ul class="down_item">
                        <li class="item_info">
                            <img src="../assets/images/cleanser_skincare_pro.png" alt="">
                            <div class="item_detail">
                                <div class="item_detail_name">洁面手法和使用频率</div>
                                <p class="item_detail_desc">{{guidedata.desc.cleanser_usage}}<br>{{guidedata.desc.usage_frequency}}</p>
                            </div>
                        </li>
                        <li class="item_info">
                            <img src="../assets/images/cleanser_usage_frequency.png" alt="">
                            <div class="item_detail">
                                <div class="item_detail_name">护肤搭配</div>
                                <p class="item_detail_desc">{{guidedata.desc.skincare_match}}</p>
                            </div>
                        </li>
           
                    </ul>
                    <div class="down_title">特殊护理</div>
                    <ul class="down_item_special_care">
                      <li class="down_item_special_care_li">
                        <div class="item_title">脂溢性皮肤如：痤疮、脂溢性皮炎等</div>
                        <p class="item_desc">有明显丘疹、脓包的情况建议使用含二硫化硒或硫磺的产品达到控油抑菌作用；</p>
                        <p class="item_desc">痘痘爆发期避免使用磨砂膏、泥状清洁面膜</p>
                      </li>
                      <li class="down_item_special_care_li">
                        <div class="item_title">红血丝、脸颊泛红、玫瑰痤疮等</div>
                        <p class="item_desc">温和清洁：使用温和的泛红肤质可用的洁面产品（避免酒精、金缕梅、香精、薄荷、桉树油等会对红斑出现刺激的成分）；</p>
                        <p class="item_desc">用手指轻柔打圈按摩；温水冲洗干净，不可有洁面残留，否则会对皮肤产生刺激；</p>
                        <p class="item_desc">用干净毛巾轻轻蘸取吸干水分；</p>
                        <p class="item_desc">淋浴时最好不超过10分钟，过热的水冲洗太长时间会使泛红加重</p>
                      </li>
                      <li class="down_item_special_care_li">
                        <div class="item_title">黄褐斑/日晒斑</div>
                        <p class="item_desc">如果有面部色斑，如黄褐斑日晒斑，一定要注意使用温和产品，因为外部的刺激会使色斑加重；避免热瑜伽、蒸桑拿等活动；</p>
                        <p class="item_desc">外出注意做好防晒措施</p>
                      </li>
                    </ul>
           
                </div>

		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
import { setTimeout } from 'timers';
var wx = require("weixin-js-sdk");
export default {
  name: "CleanserGuide",
  data() {
    return {
      isload: false,
      focused_idx:0,
      focused_left:0,
      focused_width:0,
      triangle_left:30,  //成分详情icon
      in_weapp: false, //是否在小程序
      guidedata:null,
      show_rec:true,  //早晚护肤列表
      show_oth:false,  //对应类型产品
      filter_idx:0,   //洁面产品推荐 菜单
      rec_pro_list:null,   //推荐产品列表
      avoid_pro_list:null,   //规避产品列表
      recommend:0,  //产品筛选条件 是否推荐
      cleanser:0,  //产品筛选条件 清洁力强
      essence:0,  //产品筛选条件  有无香精
      risk:0,   //产品筛选条件  有无风险性防腐剂
      soap_base:0,  //产品筛选条件  是否皂基
      emulsion_type:0,  //产品筛选条件  是否乳化性 
      redo_survey:true,
      show_cleanser_toaster:false,
      cleanser_toaster_text:[]
    };
  },

  created() {
    console.log("skincareguide created", this);
    this.initCleanserGuide();
    this.getRedoSurveyShowStatus();
  },
  mounted() {
        setTimeout(() => {
			this.changeFocusedTab(this.focused_idx);
		}, 500);
      
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {

    changeFocusedTab: function(idx) {
			this.focused_idx = idx;
			console.log(271, this.$refs['focused_item_' + idx]);
			this.focused_width = this.$refs['focused_item_' + idx].clientWidth;
			this.focused_left = this.$refs['focused_item_' + idx].offsetLeft;
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    getRedoSurveyShowStatus:function(){   //获取基因问卷第一题 及表型数据 判断是否展示重填问卷
      let that = this;
      that.$jsonp("https://www.uniskin.com.cn/reportv2/index/report199_ex1/getGeneQs1Survey")
      .then( json => {
        console.log("redo_survey",json);
        if(json.code == 0){
         if(!(json.data.qs1 == 'E') || json.data.skin_type.length > 0){
           that.redo_survey = false;
         }else{
           that.redo_survey = true;
         }
         
        }else if(json.code == 100){
          alert("请先登录");
          location.href = "https://www.uniskin.com.cn/mall/member/account/login";
        }else{
          alert(json.msg);
        }
      })
      .catch( err => {
        console.log(err);
            
      })
    },
    initProList:function(){  //获取蟾皮列表
      let that = this;
      that.$jsonp("https://www.uniskin.com.cn/reportv2/index/report199_ex1/getCleanserRecommendGoods",{recommend:that.recommend,cleanser:that.cleanser,essence:that.essence,risk:that.risk,soap_base:that.soap_base})
      .then( json => {
        console.log("推荐",json);
        if(json.code == 0){
          that.rec_pro_list = json.data.recommend;
          console.log('rec_pro',that.rec_pro_list);
          that.avoid_pro_list = json.data.avoid;
          console.log('prolist',json);
        }else if(json.code == 100){
          alert("请先登录");
          location.href = "https://www.uniskin.com.cn/mall/member/account/login";
        }else{
          alert(json.msg);
        }
      })
      .catch( err => {
        console.log(err);
            // location.href = "https://www.uniskin.com.cn/mall/member/account/login";
      })

    },
    initCleanserGuide: function() {
      let that = this;
      var local_cleanser_guide = JSON.parse(localStorage.getItem("local_cleanser_guide"));
      if (local_cleanser_guide) {
        afterCleanserGuide(local_cleanser_guide);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getCleanserRecommendGoods",{recommend:that.recommend,cleanser:that.cleanser,essence:that.essence,risk:that.risk,soap_base:that.soap_base}
          )
          .then(json => {
            console.log(json);
            afterCleanserGuide(json);
            // localStorage.setItem("local_cleanser_guide",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterCleanserGuide(guidedata) {
        if (guidedata.code == 0) {
          that.isload = true;
          that.guidedata = guidedata.data;
          that.rec_pro_list = guidedata.data.recommend;

          //规避产品移至最后
          // let my_recommend = guidedata.data.recommend;
          // my_recommend.forEach(
          //   (v,i) => {
          //     console.log('v',v);
          //     if(v.avoid == 1){
          //        let pushed_item = v;
          //        my_recommend.splice(my_recommend.indexOf('v'),1);
          //        my_recommend.push(pushed_item);
          //     }
              
          //   }
          // )
          // that.rec_pro_list = my_recommend;
          console.log('rec_pro',that.rec_pro_list);
          that.avoid_pro_list = guidedata.data.avoid;
          let user_skintype = guidedata.data.desc.skin_type;
          if(user_skintype == '干性不敏感'){
            that.cleanser_toaster_text = ["清洁力偏弱的洁面产品"];
          }else if(user_skintype == '干性敏感'){
            that.cleanser_toaster_text = ["清洁力偏弱、无香精、无风险防腐剂","非皂基的洁面产品"];
          }else if(user_skintype == '中性不敏感'){
            that.cleanser_toaster_text = ["清洁力中等偏强的洁面产品"];
          }else if(user_skintype == '中性敏感'){
            that.cleanser_toaster_text = ["清洁力中等偏弱、无香精、无风险防腐剂","非皂基的洁面产品"];
          }else if(user_skintype == '油性不敏感'){
            that.cleanser_toaster_text = ["清洁力较强的洁面产品"];
          }else if(user_skintype == '油性敏感'){
            that.cleanser_toaster_text = ["清洁力较强、无香精、无风险防腐剂","非皂基的洁面产品"];
          }

        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
.cleanser_sub_result_part{
  margin-bottom:54/50rem;
  position:relative;
  .shadow;
  .border-radius(14/50rem);
  padding:34/50rem 30/50rem 65/50rem;
  background:#fcfcfc;
  .cleanser_sub_result_title{
    font-size:24/50rem;
    line-height:1em;
    color:@font-c-3;
    padding-bottom:50/50rem;
  }
  .cleanser_sub_result_show_text{
    position:absolute;
    top:30/50rem;
    right:0;
    width:119/50rem;
    height:35/50rem;
    line-height:35/50rem;
    font-size:22/50rem;
    color:#f99d9b;
    background:#ffe6e3;
    text-align:center;
    .border-radius-side(18/50rem,0,0,18/50rem);
  }
  .cleanser_sub_result_text{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    text-align:center;
    strong{
      font-size:28/50rem;
      line-height:1.1em;
      color:@font-c-3;
      text-align:center;
      border-bottom:1px solid #f99d9b;
      margin-bottom:10/50rem;
    }
  }
}
.cleanser_toaster{
  position:fixed;
  z-index:999;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background:rgba(0,0,0,0.3);
  .cleanser_toaster_inner{
    padding:0 30/50rem;
    background:#fff;
    .shadow;
    .border-radius(15/50rem);
    position:absolute;
    top:50%;
    left:50%;
    -webkit-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
    width:596/50rem;
    height:547/50rem;
    .cleanser_toaster_inner_title{
      padding-top:73/50rem;
      padding-bottom:20/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      strong{
        font-size:30/50rem;
        line-height:1.1em;
        color:@font-c-3;
        font-weight:bold;
        border-bottom:1px solid @font-c-3;
      }
    }
    .cleanser_toaster_inner_2nd_title{
      padding-top:28/50rem;
      font-size:28/50rem;
      line-height:42/50rem;
      color:#f99d9b;
    }
    .cleanser_toaster_inner_text{
      font-size:22/50rem;
      line-height:26/50rem;
      color:@font-c-6;
    }
    .cleanser_inner_close_btn{
      position:absolute;
      top:30/50rem;
      right:30/50rem;
      width:30/50rem;
      height:30/50rem;
    }
  }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.inner_up{
    padding:106/50rem 30/50rem 0;
    background:@font-c-f;
    .shadow;
    .guide_title{
      position:relative;
        padding-bottom:86/50rem;
        font-size:44/50rem;
        font-weight:bold;
        line-height:1em;
        text-align:center;
        color:@font-c-3;
        span{
          position:absolute;
          bottom:86/50rem;
          right:0;
          white-space:nowrap;
          display:inline-block;
          font-size:24/50rem;
          line-height:1em;
          color:@font-c-detail;
          border-bottom:1px solid @font-c-detail;
          margin-left:20/50rem;
        }
    }
    .detail_menu {
    position:relative;
    box-sizing: border-box;
    // .shadow;
    // padding: 81/50rem 30/50rem 0/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .menu_item {
      padding-bottom: 27/50rem;
      .align-items_flex-end;
      .flex_0;
      width: 33.33%;
      font-size: 28/50rem;
      line-height: 1em;
      text-align: center;
      color: @font-c-3;
      border-bottom: 3px solid transparent;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        color:@font-c-detail;
        // border-bottom: 3px solid #f099a6;
      }
    }
  }
    .bg_div{
    position:absolute;
    bottom:0;
    height:3px;
    width:1/50rem;
    background:@font-c-detail;
    -webkit-transition:left 0.5s;
    transition:left 0.5s;
    }
}
.inner_down{
    padding:53/50rem 30/50rem 104/50rem;
}
//特征分析
.inner_down_first{
    .down_title{
        padding-bottom:27/50rem;
        font-size:34/50rem;
        font-weight:bold;
        line-height:1em;
        color:@font-c-3;
    }
    .down_item{
        box-sizing:border-box;
        margin-bottom:50/50rem;
        .border-radius(14/50rem);
        .shadow;
    }
    .down_item_mine{
        padding:49/50rem 35/50rem 57/50rem;
        .down_item_mine_result{
            position:relative;
            padding-left:20/50rem;
            margin-bottom:20/50rem;
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-3;
            &::before{
                content:"";
                display:block;
                position:absolute;
                top:50%;
                left:0;
                transform:translateY(-50%) scale(0.5);
                width:10px;
                height:10px;
                border-radius:50%;
                background:@font-c-0;

            }
        }
        .down_item_mine_summary{
            margin-top:18/50rem;
            padding:30/50rem;
            background:#ffe6e3;
            color:@font-c-detail;
            font-size:26/50rem;
            line-height:30/50rem;
            .border-radius(14/50rem);
        }
    }
    .down_item_suitfor{
        padding:32/50rem 35/50rem 11/50rem;
        .display_flex;
        .flex-wrap_wrap;
        .justify-content_flex-start;
        .down_item_suitfor_name{
            margin:0 20/50rem 24/50rem 0;
            padding:11/50rem 30/50rem;
            .border-1px-suitfor;
            font-size:24/50rem;
            line-height:1em;
            color:#78d153;
        }
    }
    .down_item_avoid{
        padding:32/50rem 35/50rem 11/50rem;
        .display_flex;
        .flex-wrap_wrap;
        .justify-content_flex-start;
        .down_item_avoid_name{
            margin:0 20/50rem 24/50rem 0;
            padding:11/50rem 30/50rem;
            .border-1px-avoid;
            font-size:24/50rem;
            line-height:1em;
            color:#fd9e5c;
        }
    }
    .down_item_science{
        padding:56/50rem 45/50rem 52/50rem;
        .down_item_science_title{
            padding:46/50rem 0 14/50rem;
            font-size:34/50rem;
            font-weight:bold;
            line-height:1.1em;
            color:@font-c-3;
        }
        img{
            width:100%;
        }
        .down_item_science_desc{
          font-size:24/50rem;
          line-height:30/50rem;
          color:@font-c-9;
        }
    }
    

}

//产品推荐
.inner_down_second{
  .down_title{
    padding-bottom:28/50rem;
    font-size:34/50rem;
    line-height:1em;
    font-weight:bold;
    color:@font-c-3;
  }
  .filter_menu_outer{
    -webkit-overflow-x:scroll;
    overflow-x:scroll;
    &::-webkit-scrollbar{
      display:none;
    }
  }
  .filter_menu{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    padding-bottom:1px;
    .menu_item{
      // .border-1px;
      .flex_0;
      .border-radius(25/50rem);
      box-sizing:border-box;
      border:1px solid @font-c-detail;
      padding:13/50rem 30/50rem;
      margin-right:20/50rem;
      font-size:28/50rem;
      line-height:1em;
      color:@font-c-detail;
      background:transparent;
      &.now{
        box-sizing:border-box;
        background:@font-c-detail;
        .border-radius(25/50rem);
        color:@font-c-f;
      }
    }

  }
  .filter_pro_list{
    padding:22/50rem 0 191/50rem;
    .filter_pro{
      position:relative;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      .filter_pro_pic,.filter_pro_info{
        .align-self_center;
      }
      .filter_pro_pic{
        width:163/50rem;
      }
      .filter_pro_info{
        width:514/50rem;
        box-sizing:border-box;
        padding:45/50rem 0 45/50rem 12/50rem;
        // border-bottom:1px solid @font-c-detail;
        .border-bottom;
        .pro_name{
          font-size:30/50rem;
          line-height:1em;
          color:@font-c-3;
        }
        .pro_price{
          padding:13/50rem 0 26/50rem;
          font-size:24/59rem;
          line-height:1em;
          color:@font-c-9;
        }
        .pro_buy{
          padding-top:30/50rem;
          .display_flex;
          .flex-wrap_nowrap;
          .justify-content_flex-end;
          span,img{
            .align-self_center;
          }
          span{
            padding-right:10/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:#f99d9b;
          }
          img{
            width:27/50rem;
            height:27/50rem;
          }
        }
        .pro_tags{
          .display_flex;
          .flex-wrap_wrap;
          .justify-content_flex-start;
          .tag{
            box-sizing:border-box;
            padding:8/50rem 25/50rem;
            margin-right:20/50rem;
            .border-radius(23/50rem);
            background:#ffe6e3;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
          }
        }
      }
      &.now::after{
        content:"推荐";
        display:block;
        width:74/50rem;
        height:74/50rem;
        .border-radius(50%);
        text-align:center;
        background:#ffe6e3;
        color:@font-c-detail;
        font-size:24/50rem;
        line-height:74/50rem;
        position:absolute;
        top:75/50rem;
        right:38/50rem;
      }
      &.avoid::after{
        content:"规避";
        display:block;
        width:74/50rem;
        height:74/50rem;
        .border-radius(50%);
        text-align:center;
        background:#ffe6e3;
        color:@font-c-detail;
        font-size:24/50rem;
        line-height:74/50rem;
        position:absolute;
        top:75/50rem;
        right:38/50rem;
      }
    }
  }

}

//使用建议
.inner_down_third{
  .down_title{
        padding-bottom:28/50rem;
        font-size:34/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
  }
  .down_item{
      padding:0 0rem 70/50rem;
  }
  .item_info{
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-justify;
      padding-bottom:40/50rem;
      img{
          .flex_0;
          width:140/50rem;
          height:140/50rem;
          background:#fcfcfc;
          .shadow;
          .border-radius(14/50rem);
      }
      .item_detail{
          .flex_0;
          width:525/50rem;
          .item_detail_name{
               padding:10/50rem 0 11/50rem;
              font-size:30/50rem;
              line-height:1em;
              font-weight:bold;
              color:@font-c-3;
          }
          .item_detail_desc{
             font-size:24/50rem;
             line-height:30/50rem;
             color:@font-c-6;
          }
      }
  }
  .down_item_special_care{

  }
  .down_item_special_care_li{
    padding-bottom:23/50rem;
    .item_title{
      font-size:28/50rem;
      line-height:1em;
      color:@font-c-detail;
      padding-bottom:6/50rem;
    }
    .item_desc{
      position:relative;
      padding:0 0 5/50rem 26/50rem;
      font-size:24/50rem;
      line-height:30/50rem;
      color:@font-c-6;
      &::before{
        content:"";
        display:block;
        position:absolute;
        top:7/50rem;
        left:0;
        -webkit-transform:scale(0.5);
        transform:scale(0.5);
        width:10px;
        height:10px;
        .border-radius(50%);
        background:@font-c-0;
      }
    }
  }
}


</style>
